var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("resizable-common-dialog", {
    ref: "dialog",
    attrs: {
      title: "Group",
      "dialog-visible": _vm.visible,
      rules: "rules",
      "start-dialog-height": "230",
      "start-dialog-width": "320",
    },
    on: {
      "update:dialogVisible": function ($event) {
        _vm.visible = $event
      },
      "update:dialog-visible": function ($event) {
        _vm.visible = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c(
                  "v-row",
                  { staticClass: "mt-3", attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "12", sm: "12" } },
                      [
                        _c("v-combobox", {
                          directives: [
                            { name: "ascii-only", rawName: "v-ascii-only" },
                          ],
                          attrs: {
                            label: "Name:",
                            items: _vm.existingGroups,
                            dense: "",
                            "search-input": _vm.searchInput,
                          },
                          on: {
                            "update:searchInput": function ($event) {
                              _vm.searchInput = $event
                            },
                            "update:search-input": function ($event) {
                              _vm.searchInput = $event
                            },
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "name",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.hide },
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.save },
              },
              [_vm._v("Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }